import {
  ApiResponse,
  Season,
  Sport,
  SportId,
} from '@collector/sportsapi-client-legacy'

import { HttpClient } from '../httpClient.js'

export type SportGetByIdResponse = ApiResponse<{
  sport: Sport
}>

export async function getById(
  httpClient: HttpClient,
  sportId: SportId,
  seasonId: Season['id'],
): Promise<SportGetByIdResponse> {
  return httpClient
    .url(`/sports/${sportId}`)
    .query({ season_id: seasonId })
    .get()
    .json()
}
